import React, { useEffect } from "react";
import ContactHeroSection from "../components/Contact/ContactHeroSection";
import ContactMotivationBanner from "../components/Contact/ContactMotivationBanner";
import ContactFormSection from "../components/Contact/ContactFormSection"
import GymCardsSection from "../components/Contact/GymCardsSection";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <ContactHeroSection />
      <GymCardsSection />
      <ContactMotivationBanner />
      <ContactFormSection />
    </div>
  );
}

export default Contact;